module.exports = __webpack_public_path__ + "static/img/标题-玛纳斯.e2d390d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/head/标题-玛纳斯.png
// module id = 0DO1
// module chunks = 0